if (!customElements.get('nightjar-navigation')) {
  customElements.define('nightjar-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('.nj-menu-open');
      const closer = this.querySelector('.nj-menu-close');
      if (!dialog || !opener || !closer) return;
      const close = () => dialog.close();
      opener.addEventListener('click', () => {
        if (dialog.open) return;
        dialog.showModal();
        opener.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('nj-menu-is-open');
        closer.focus();
      });
      closer.addEventListener('click', close);
      dialog.addEventListener('close', () => {
        opener.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('nj-menu-is-open');
        opener.focus();
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      });
      dialog.querySelectorAll('a').forEach(link => link.addEventListener('click', close));
    }
    disconnectedCallback() {
      const dialog = this.querySelector('dialog');
      if (dialog && dialog.open) dialog.close();
      document.documentElement.classList.remove('nj-menu-is-open');
    }
  });
}
